import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Swal from "sweetalert2";
import CryptoJS from "crypto-js";
// import devtools from "devtools-detect";
import config from "./config";
import DynamicTitle from "./dynamictitle/DynamicTitle.jsx";
import { BoardProvider } from "./context/ContextBoard";
import { decryptConfig } from "./UI/Decrypt";
// Private Routes
import PrivateRoute from "./components/PrivateRoute";
import PrivateRoute10 from "./components/PrivateRoute10.jsx";
import PrivateRoute11 from "./components/PrivateRoute11.jsx";
import PrivateRoute12 from "./components/PrivateRoute12.jsx";
import PrivateRouteDeo from "./components/PrivateRouteDeo";
import PrivateRouteSecondaryAccounts from "./components/PrivateRouteSecondaryAccounts";
import PrivateRouteItermediateAccounts from "./components/PrivateRouteIntermediateAccounts";

// No Access & Misc
import BonManus from "./no-access/BonManus";
import Noaccess from "./no-access/Noaccess";
import UnsupportedBrowser from "./UI/UnsupportedBrowser.jsx";

// 🌍 Landing Pages
import SecondaryLanding from "./landing/SecondaryLanding";
import IntermediateLanding from "./landing/IntermediateLanding";
import Maintenance from "./landing/Maintenance.jsx";

// ========================== CLASS IX ==========================
import Login from "./class-ix/pages/Login";
import Dashboard from "./class-ix/pages/Dashboard";
import Schoolprofile from "./class-ix/pages/Schoolprofile";
import TotalRegistration from "./class-ix/pages/TotalRegistration";
import Checklistgenerated from "./class-ix/pages/Checklistgenerated";
import Pendingdeo from "./class-ix/pages/Pendingdeo";
import Approveddeo from "./class-ix/pages/Approveddeo";
import Rejectdeo from "./class-ix/pages/Rejectdeo";
import GenerateChallan from "./class-ix/pages/Generatechallan";
import Challanstatus from "./class-ix/pages/Challanstatus";
import Consolidatedchecklist from "./class-ix/pages/Consolidatedchecklist";
import Addstudentregular from "./class-ix/pages/Addstudentregular";
import Exregularfirst from "./class-ix/pages/Exregularfirst";
import Exregularsecond from "./class-ix/pages/Exregularsecond";
import Document from "./class-ix/pages/Document";
import Checklist from "./class-ix/pages/Checklist";
import GeneratePDFIX from "./class-ix/pages/GeneratePDFIX";
import BackdoorLogin from "./class-ix/pages/BackdoorLogin.jsx";
import ListofExamineesPDF from "./class-ix/pages/ListofExamineesPDF.jsx";
import DataNotFound from "./class-ix/pages/DataNotFound.jsx";
import DataNotFoundList from "./class-ix/pages/DataNotFoundList.jsx";

// ========================== CLASS X ==========================
import Login10 from "./class-x/pages/Login10";
import BackdoorLogin10 from "./class-x/pages/BackdoorLogin10";
import Dashboard10 from "./class-x/pages/Dashboard10";
import Schoolprofile10 from "./class-x/pages/Schoolprofile10";
import TotalRegistration10 from "./class-x/pages/TotalRegistration10";
import GenerateChallan10 from "./class-x/pages/Generatechallan10";
 import GenerateChallanLateral10 from "./class-x/pages/GenerateChallanLateral10.jsx";
import Challanstatus10 from "./class-x/pages/Challanstatus10";
import Consolidatedchecklist10 from "./class-x/pages/Consolidatedchecklist10";
import Addstudentregular10 from "./class-x/pages/Addstudentregular10";
import Exregularfirst10 from "./class-x/pages/Exregularfirst10";
import Exregularsecond10 from "./class-x/pages/Exregularsecond10";
import Improvementfirst from "./class-x/pages/Improvementfirst";
import Improvementsecond from "./class-x/pages/Improvementsecond";
import Addstudentregularsecond from "./class-x/pages/Addstudentregularsecond";
import Document10 from "./class-x/pages/Document10";
import GeneratePDFX10 from "./class-x/pages/GeneratePDFX.jsx";
import ListofExamineesPDF10 from "./class-x/pages/ListofExamineesPDF10";
import Checklistgenerated10 from "./class-x/pages/Checklistgenerated10";
import DataNotFound10 from "./class-x/pages/DataNotFound10";
import DataNotFoundList10 from "./class-x/pages/DataNotFoundList10";

// ========================== CLASS XI ==========================
import Dashboard11 from "./class-xi/pages/Dashboard11";
import Login11 from "./class-xi/pages/Login11";
import Schoolprofile11 from "./class-xi/pages/Schoolprofile11";
import Addjacstudent11 from "./class-xi/pages/Addjacstudent11";
import TotalRegistration11 from "./class-xi/pages/TotalRegistration11";
import Checklistgenerated11 from "./class-xi/pages/Checklistgenerated11";
import GenerateChallan11 from "./class-xi/pages/Generatechallan11";
import Challanstatus11 from "./class-xi/pages/Challanstatus11";
import Consolidatedchecklist11 from "./class-xi/pages/Consolidatedchecklist11";
import Addstudentothers11 from "./class-xi/pages/Addstudentothers11";
import Addjacstudent11page2 from "./class-xi/pages/Addjacstudent11page2";
import Addexregular11 from "./class-xi/pages/Addexregular11";
import GeneratePDFXI from "./class-xi/pages/GeneratePDFXI.jsx";
import Board2020registration from "./class-xi/pages/Board2020registration";
import Addexregularsecond11 from "./class-xi/pages/Addexregularsecond11";
import Document11 from "./class-xi/pages/Document11";
import ListofExamineesPDF11 from "./class-xi/pages/ListofExamineesPDF11.jsx";
import BackdoorLogin11 from "./class-xi/pages/Backdoorlogin11.jsx";
import DataNotFound11 from "./class-xi/pages/DataNotFound11.jsx";
import DataNotFoundList11 from "./class-xi/pages/DataNotFoundList11.jsx";

// ========================== CLASS XII ==========================
import Login12 from "./class-xii/pages/Login12";
import BackdoorLogin12 from "./class-xii/pages/Backdoorlogin12";
import Dashboard12 from "./class-xii/pages/Dashboard12";
import Schoolprofile12 from "./class-xii/pages/Schoolprofile12";
import TotalRegistration12 from "./class-xii/pages/TotalRegistration12";
import Checklistgenerated12 from "./class-xii/pages/Checklistgenerated12";
import GenerateChallan12 from "./class-xii/pages/Generatechallan12";
import GenerateLateralChallan12 from "./class-xii/pages/GenerateLateralChallan12.jsx";
import Consolidatedchecklist12 from "./class-xii/pages/Consolidatedchecklist12";
import Challanstatus12 from "./class-xii/pages/Challanstatus12";
import Addexregular12 from "./class-xii/pages/Addexregular12";
import Addimprovement12 from "./class-xii/pages/Addimprovement12";
import Addqualifying12 from "./class-xii/pages/Addqualifying12";
import Addstudentregular12 from "./class-xii/pages/Addstudentregular12";
import Addstudentregularsecond12 from "./class-xii/pages/Addstudentregularsecond12";
import Addexregularsecond12 from "./class-xii/pages/Addexregularsecond12";
import Addimprovementsecond12 from "./class-xii/pages/addimprovementsecond12";
import Addqualifyingsecond12 from "./class-xii/pages/Addqualifyingsecond12";
import Document12 from "./class-xii/pages/Document12";
import GeneratePDFXII from "./class-xii/pages/GeneratePDFXII.jsx";
import ListofExamineesPDF12 from "./class-xii/pages/ListofExamineesPDF12.jsx";
import DataNotFound12 from "./class-xii/pages/DataNotFound12.jsx";
import DataNotFoundList12 from "./class-xii/pages/DataNotFoundList12.jsx";

// ========================== DEO PORTAL ==========================
import DEOlogin from "./DEO-portal/pages/DEOlogin";
import DEObackdoorLogin from "./DEO-portal/pages/DEObackdoorLogin.jsx";
import DEOdashboard from "./DEO-portal/pages/DEOdashboard";
import Pendingforapproval from "./DEO-portal/pages/Pendingforapproval";
import Totalapproved from "./DEO-portal/pages/Totalapproved";
import DEOrejected from "./DEO-portal/pages/DEOrejected";
import Totalschools from "./DEO-portal/pages/Totalschools";
import Initiateverification from "./DEO-portal/pages/Initiateverification";
import PendingApplicantsPage from "./DEO-portal/pages/TotalPendingApplicant";
import TotalApprovedApplicant from "./DEO-portal/pages/TotalApprovedApplicant";
import TotalRejectedApplicant from "./DEO-portal/pages/TotalRejectedApplicant";
import TotalApplicant from "./DEO-portal/pages/TotalApplicantsPage";

// ========================== ACCOUNTS (Secondary) ==========================
import AccountsLoginSecondary from "./accounts-secondary/pages/login";
import AccountsDashboardSecondary9 from "./accounts-secondary/pages/dashboard9";
import AccountsDashboardSecondary10 from "./accounts-secondary/pages/dashboard10";
import PaymentPendingSecondary9 from "./accounts-secondary/pages/Paymentpending9";
import PaymentPendingSecondary10 from "./accounts-secondary/pages/Paymentpending10";
import RejectedPaymentsSecondary9 from "./accounts-secondary/pages/Rejectedpayments9";
import RejectedPaymentsSecondary10 from "./accounts-secondary/pages/Rejectedpayments10";
import VerifiedPaymentsSecondary9 from "./accounts-secondary/pages/Verifiedpayments9";
import VerifiedPaymentsSecondary10 from "./accounts-secondary/pages/Verifiedpayments10";
import ChallanPendingSubmissionSecondary9 from "./accounts-secondary/pages/Challanpendingsubmission9";
import ChallanPendingSubmissionSecondary10 from "./accounts-secondary/pages/Challanpendingsubmission10";
import ChallanNotGeneratedSecondary9 from "./accounts-secondary/pages/ChallanNotGenerated9";
import ChallanNotGeneratedSecondary10 from "./accounts-secondary/pages/ChallanNotGenerated10";
import FeesStructureSecondaryCL9 from "./accounts-secondary/pages/FeesStructure9";
import FeesStructureSecondaryCL10 from "./accounts-secondary/pages/FeesStructure10";
import ReportsSecondary from "./accounts-secondary/pages/ReportsSecondary.jsx";

// ========================== ACCOUNTS (Intermediate) ==========================
import AccountsLoginIntermediate from "./accounts-intermediate/pages/login";
import AccountsDashboardIntermediate11 from "./accounts-intermediate/pages/dashboard11";
import AccountsDashboardIntermediate12 from "./accounts-intermediate/pages/dashboard12";
import PaymentPendingIntermediate11 from "./accounts-intermediate/pages/Paymentpending11";
import PaymentPendingIntermediate12 from "./accounts-intermediate/pages/Paymentpending12";
import RejectedPaymentsIntermediate11 from "./accounts-intermediate/pages/Rejectedpayments11";
import RejectedPaymentsIntermediate12 from "./accounts-intermediate/pages/Rejectedpayments12";
import VerifiedPaymentsIntermediate11 from "./accounts-intermediate/pages/Verifiedpayments11";
import VerifiedPaymentsIntermediate12 from "./accounts-intermediate/pages/Verifiedpayments12";
import ChallanPendingSubmissionIntermediate11 from "./accounts-intermediate/pages/Challanpendingsubmission11";
import ChallanPendingSubmissionIntermediate12 from "./accounts-intermediate/pages/Challanpendingsubmission12";
import ReportsIntermediate11 from "./accounts-intermediate/pages/ReportsIntermediate11";
import ReportsIntermediate12 from "./accounts-intermediate/pages/ReportsIntermediate12";
import FeesStructureIntermediate11 from "./accounts-intermediate/pages/FeesStructure11";
import FeesStructureIntermediate12 from "./accounts-intermediate/pages/FeesStructure12";

// ========================== ADMIN (Secondary) ==========================
import AdminLoginSecondary from "./admin-secondary/pages/login";
import AdminDashboardSecondary from "./admin-secondary/pages/dashboard";
import EditSchoolSecondary from "./admin-secondary/pages/editschool";
import AddSchoolSecondary from "./admin-secondary/pages/addschool";
import DeoListSecondary from "./admin-secondary/pages/deolist";
import SchoolListSecondary from "./admin-secondary/pages/schoollist";
import TickerMasterSecondary from "./admin-secondary/pages/tickermaster";
import UploadNotice9Secondary from "./admin-secondary/pages/uploadnotice9";
import UploadNotice10Secondary from "./admin-secondary/pages/uploadnotice10";
import ClassixReportsSecondary from "./admin-secondary/pages/class9Reports";
import ClassxReportsSecondary from "./admin-secondary/pages/class10Reports";
import ChallanCancelSecondary9 from "./admin-secondary/pages/ChallanCancel9";
import ChallanCancelSecondary10 from "./admin-secondary/pages/ChallanCancel10";
import DataNotFoundSecondary9 from "./admin-secondary/pages/dataNotFoundList9";
import DataNotFoundSecondary10 from "./admin-secondary/pages/dataNotFoundList10";
import DataNotFountListDetails9 from "./admin-secondary/pages/DataNotFountListDetails9.jsx";
import DataNotFountListDetails10 from "./admin-secondary/pages/DataNotFountListDetails10.jsx";
import NotFoundList9 from "./admin-secondary/pages/NotFoundList9.jsx";
import DataNotfound9 from "./admin-secondary/pages/dataNotFoundList9";
import NotFoundList10 from "./admin-secondary/pages/NotFoundList10.jsx";
import StudentDataNotfound10 from "./admin-secondary/pages/dataNotFoundList10";
import Studentcorrection from "./admin-secondary/pages/studentcorrection";
import StudentCorrectionPage from "./admin-secondary/pages/StudentCorrectionPage.jsx";

// ========================== ADMIN (Intermediate) ==========================
import AdminLoginIntermediate from "./admin-intermediate/pages/login";
import AdminDashboardIntermediate from "./admin-intermediate/pages/dashboard";
import AddSchoolIntermediate from "./admin-intermediate/pages/addschool";
import DeoListIntermediate from "./admin-intermediate/pages/deolist";
import IntakeQuotaIntermediate from "./admin-intermediate/pages/intakequota";
import IntakeQuotaAllocationIntermediate from "./admin-intermediate/pages/intakequotaallocation";
import SchoolListIntermediate from "./admin-intermediate/pages/schoollist";
import EditSchoolIntermediate from "./admin-intermediate/pages/editschool";
import AddSchool from "./admin-intermediate/pages/addschool";
import StudentCorrectionIntermediate from "./admin-intermediate/pages/studentcorrection";
import ViewSchoolDetailsIntermediate from "./admin-intermediate/pages/viewschooldetails";
import TickerMasterIntermediate from "./admin-intermediate/pages/tickermaster";
import UploadNoticeIntermediate11 from "./admin-intermediate/pages/uploadnotice11";
import UploadNoticeIntermediate12 from "./admin-intermediate/pages/uploadnotice12";
import ClassxiReportsIntermediate from "./admin-intermediate/pages/class11Reports";
import ClassxiiReportsIntermediate from "./admin-intermediate/pages/class12Reports";
import ChallanCancelIntermediate11 from "./admin-intermediate/pages/ChallanCancel11";
import ChallanCancelIntermediate12 from "./admin-intermediate/pages/ChallanCancel12";
// import DataNotFoundIntermediate11 from "./admin-intermediate/pages/dataNotFoundList11";
// import DataNotFoundIntermediate12 from "./admin-intermediate/pages/dataNotFoundList12";
import DataNotFountListDetails11 from "./admin-intermediate/pages/DataNotFountListDetails11";
import DataNotFountListDetails12 from "./admin-intermediate/pages/DataNotFountListDetails12";
import NotFoundList11 from "./admin-intermediate/pages/NotFoundList11";
import DataNotfoundListInter12 from "./admin-intermediate/pages/dataNotFoundListInter12";
import NotFoundList12 from "./admin-intermediate/pages/NotFoundList12";
import DataNotfoundListInter11 from "./admin-intermediate/pages/dataNotFoundListInter11";
import Studentcorrection11 from "./admin-intermediate/pages/studentcorrection";
import StudentCorrectionPage11 from "./admin-intermediate/pages/StudentCorrectionPage.jsx";   


//student-correction
import CorrectStudentPage1 from "./class-x/pages/CorrectStudentPage1.jsx";
import CorrectionRegular from "./class-x/pages/CorrectionRegular.jsx";
import CorrectExregular from "./class-x/pages/CorrectExregular.jsx";
import CorrectImprovement from "./class-x/pages/CorrectImprovement.jsx";


import CorrectStudent12 from "./class-xii/pages/CorrectStudent12.jsx";
import CorrectRegular12 from "./class-xii/pages/CorrectRegular12.jsx";
import CorrectExregular12 from "./class-xii/pages/CorrectExregular12.jsx";
import CorrectBetterment12 from "./class-xii/pages/CorrectBetterment12.jsx";
import CorrectQualify12 from "./class-xii/pages/CorrectQualify12.jsx";


import CorrectStudentRegular9 from "./class-ix/pages/CorrectStudentRegular9.jsx";
import CorrectStudentPage9 from "./class-ix/pages/CorrectStudentPage9.jsx";
import CorrectStudentExregular9 from "./class-ix/pages/CorrectStudentExregular9.jsx";

import CorrectStudent11 from "./class-xi/pages/CorrectStudent11.jsx";
import CorrectStudentJac11 from "./class-xi/pages/CorrectStudentJac11.jsx";
import CorrectStudentOthers11 from "./class-xi/pages/CorrectStudentOthers11.jsx";
import CorrectStudentExregular11 from "./class-xi/pages/CorrectStudentExregular11.jsx";
import CorrectStudentBeforeStudent11 from "./class-xi/pages/CorrectStudentBeforeStudent11.jsx";


function App() {
  const [class9Route, setClass9Route] = useState("");
  const [class10Route, setClass10Route] = useState("");
  const [class11Route, setClass11Route] = useState("");
  const [class12Route, setClass12Route] = useState("");
  const [class9deoroute, setClass9deoroute] = useState("");
  const [class9foroute, setClass9foroute] = useState("");
  const [class10foroute, setClass10foroute] = useState("");
  const [class11foroute, setClass11foroute] = useState("");
  const [class12foroute, setClass12foroute] = useState("");

  const [class9active, setClass9active] = useState("");
  const [class10active, setClass10active] = useState("");
  const [class11active, setClass11active] = useState("");
  const [class12active, setClass12active] = useState("");
  const [class9deoactive, setClass9deoactive] = useState("");
  const [class9foactive, setClass9foactive] = useState("");
  const [class10foactive, setClass10foactive] = useState("");
  const [class11foactive, setClass11foactive] = useState("");
  const [class12foactive, setClass12foactive] = useState("");
  // const [blocked, setBlocked] = useState(false);


  const SECRET_KEY = config.SECRET_KEY;
  function generateOneTimeToken() {
    const timestamp = Date.now();
    const nonce = CryptoJS.lib.WordArray.random(16).toString();
    const payload = `${timestamp}:${nonce}`;
    const signature = CryptoJS.HmacSHA256(payload, SECRET_KEY).toString();

    return `${timestamp}:${nonce}:${signature}`;
  }

  useEffect(() => {
    const fetchConfigData = async () => {
      try {
        const tokeng = generateOneTimeToken();
        const response = await fetch(
          `${config.API_BASE_URL}/FetchConfigurationData`,
          {
            method: "GET",
            headers: { "X-Private-Key": tokeng },
          }
        );

        const data = await response.json();
        if (response.ok) {
          const configData = decryptConfig(data?.data);
          // sessionStorage.clear();
          // console.log(configData);

          sessionStorage.setItem("class9Active", configData.cL_9_CLASS);
          sessionStorage.setItem("class10Active", configData.cL_10_CLASS);
          sessionStorage.setItem("class11Active", configData.cL_11_CLASS);
          sessionStorage.setItem("class12Active", configData.cL_12_CLASS);
          sessionStorage.setItem("class9deoActive", configData.cL_9_DEO_PORTAL);
          sessionStorage.setItem("class9foActive", configData.cL_9_FO_PORTAL);
          sessionStorage.setItem("class10foActive", configData.cL_10_FO_PORTAL);
          sessionStorage.setItem("class11foActive", configData.cL_11_FO_PORTAL);
          sessionStorage.setItem("class12foActive", configData.cL_12_FO_PORTAL);
          setClass9active(configData.cL_9_CLASS);
          setClass10active(configData.cL_10_CLASS);
          setClass11active(configData.cL_11_CLASS);
          setClass12active(configData.cL_12_CLASS);
          setClass9deoactive(configData.cL_9_DEO_PORTAL);
          setClass9foactive(configData.cL_9_FO_PORTAL);
          setClass10foactive(configData.cL_10_FO_PORTAL);
          setClass11foactive(configData.cL_11_FO_PORTAL);
          setClass12foactive(configData.cL_12_FO_PORTAL);
          
        } else {
          Swal.fire("Error", data.message || "Invalid response", "error");
        }
      } catch (error) {
        Swal.fire("Error", "Database under maintenance, please come back after few minutes.", "error");
      }
    };

    fetchConfigData();
  }, []);
//  useEffect(() => {
//     const fetchConfigData2 = async () => {
//       try {
//         const tokeng = generateOneTimeToken();
//         const response = await fetch(
//           `${config.API_BASE_URL2}/FetchConfigurationData`,
//           {
//             method: "GET",
//             headers: { "X-Private-Key": tokeng },
//           }
//         );

//         const data = await response.json();
//         if (response.ok) {
//           const configData = data?.data;
         
          
//           sessionStorage.setItem("correctionstatus_firstpage_10",configData.cL_10_CORRECTION_PORTAL);
          
//         } else {
//           Swal.fire("Error", data.message || "Invalid response", "error");
//         }
//       } catch (error) {
//         Swal.fire("Error", "Database under maintenance, please come back after few minutes.", "error");
//       }
//     };

//     fetchConfigData2();
//   }, []);
  /*  useEffect(() => {
    const handleRightClick = (e) => {
      e.preventDefault();
    };
    document.addEventListener("contextmenu", handleRightClick);

    return () => {
      document.removeEventListener("contextmenu", handleRightClick);
    };
  }, []); */

  useEffect(() => {
    // Disable right click
    document.addEventListener("contextmenu", (e) => e.preventDefault());

    // Disable keyboard shortcuts
    const disableKeys = (e) => {
      if (
        e.key === "F12" ||
        (e.ctrlKey && e.shiftKey && e.key === "I") ||  // Ctrl+Shift+I
        (e.ctrlKey && e.shiftKey && e.key === "J") ||  // Ctrl+Shift+J
        (e.ctrlKey && e.key === "U")                   // Ctrl+U
      ) {
        e.preventDefault();
      }
    };
    document.addEventListener("keydown", disableKeys);

    //Check DevTools continuously
    // const interval = setInterval(() => {
    //   if (devtools.isOpen) {
    //     setBlocked(true);
    //   } else {
    //     setBlocked(false);
    //   }
    // }, 300);

    // return () => {
    //   clearInterval(interval);
    // };
  }, []);

  const [isAllowed, setIsAllowed] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      // Tablet breakpoint: 768px (you can change this as needed)
      setIsAllowed(window.innerWidth >= 768);
    };

    checkScreenSize(); // check on load
    window.addEventListener("resize", checkScreenSize); // listen for resize

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  if (!isAllowed) {
    return <UnsupportedBrowser />;
  }
  const getActiveBaseUrl = () => {
    if (config.BASE_URL_1_STATUS === "ON") return config.BASE_URL_1;
    if (config.BASE_URL_2_STATUS === "ON") return config.BASE_URL_2;
    if (config.BASE_URL_3_STATUS === "ON") return config.BASE_URL_3;
    if (config.BASE_URL_4_STATUS === "ON") return config.BASE_URL_4;
    return "/";
  };

  const activeBaseUrl = getActiveBaseUrl();

  return (
    <BoardProvider>
      {config.BASE_URL_1_STATUS === "OFF" &&
        config.BASE_URL_2_STATUS === "OFF" &&
        config.BASE_URL_3_STATUS === "OFF" &&
        config.BASE_URL_4_STATUS === "OFF" ? (
        <Router>
          <DynamicTitle />
          <Routes>

                 {/* <Route
              path="/"
              element={<Navigate to="/Secondary" replace />}
            />
            <Route path="/Secondary" element={<SecondaryLanding />} />  */}
       <Route
                  path="/"
                  element={<Navigate to="/Intermediate" replace />}
                />
            <Route path="/Intermediate" element={<IntermediateLanding />} /> 
            {/* Secondary Accounts Routes */}
            {class9foactive === "ON" || class10foactive === "ON" ? (
              <>
                <Route
                  path="/secondary-accounts"
                  element={
                    <AccountsLoginSecondary
                      class9foroute={class9foroute}
                      setClass9foroute={setClass9foroute}
                      class10foroute={class10foroute}
                      setClass10foroute={setClass10foroute}
                    />
                  }
                />
                <Route
                  path="*"
                  element={<Navigate to="/no-access" replace />}
                />
                <Route path="/no-access" element={<Noaccess />} />
              </>
            ) : (
              ""
            )}
            {class9foactive === "ON" ? (
              <>
                <Route
                  path="/secondary-accounts-dashboard-class-ix"
                  element={
                    <PrivateRouteSecondaryAccounts>
                      <AccountsDashboardSecondary9 />
                    </PrivateRouteSecondaryAccounts>
                  }
                />
                <Route
                  path="/secondary-accounts-payment-pending-class-ix"
                  element={
                    <PrivateRouteSecondaryAccounts>
                      <PaymentPendingSecondary9 />
                    </PrivateRouteSecondaryAccounts>
                  }
                />
                <Route
                  path="/secondary-accounts-reject-payment-class-ix"
                  element={
                    <PrivateRouteSecondaryAccounts>
                      <RejectedPaymentsSecondary9 />
                    </PrivateRouteSecondaryAccounts>
                  }
                />
                <Route
                  path="/secondary-accounts-reports"
                  element={
                    <PrivateRouteSecondaryAccounts>
                      <ReportsSecondary />
                    </PrivateRouteSecondaryAccounts>
                  }
                />
                <Route
                  path="/secondary-accounts-verified-payment-class-ix"
                  element={
                    <PrivateRouteSecondaryAccounts>
                      <VerifiedPaymentsSecondary9 />
                    </PrivateRouteSecondaryAccounts>
                  }
                />
                <Route
                  path="/secondary-accounts-challan-pending-submission-class-ix"
                  element={
                    <PrivateRouteSecondaryAccounts>
                      <ChallanPendingSubmissionSecondary9 />
                    </PrivateRouteSecondaryAccounts>
                  }
                />
                <Route
                  path="/secondary-accounts-challan-not-generated-class-ix"
                  element={
                    <PrivateRouteSecondaryAccounts>
                      <ChallanNotGeneratedSecondary9 />
                    </PrivateRouteSecondaryAccounts>
                  }
                />
                <Route
                  path="/secondary-accounts-fees-structure-class-ix"
                  element={
                    <PrivateRouteSecondaryAccounts>
                      <FeesStructureSecondaryCL9 />
                    </PrivateRouteSecondaryAccounts>
                  }
                />
                <Route
                  path="*"
                  element={<Navigate to="/no-access" replace />}
                />
                <Route path="/no-access" element={<Noaccess />} />
              </>
            ) : (
              ""
            )}
            {class10foactive === "ON" ? (
              <>
                <Route
                  path="/secondary-accounts-dashboard-class-x"
                  element={
                    <PrivateRouteSecondaryAccounts>
                      <AccountsDashboardSecondary10 />
                    </PrivateRouteSecondaryAccounts>
                  }
                />
                <Route
                  path="/secondary-accounts-payment-pending-class-x"
                  element={
                    <PrivateRouteSecondaryAccounts>
                      <PaymentPendingSecondary10 />
                    </PrivateRouteSecondaryAccounts>
                  }
                />
                <Route
                  path="/secondary-accounts-reject-payment-class-x"
                  element={
                    <PrivateRouteSecondaryAccounts>
                      <RejectedPaymentsSecondary10 />
                    </PrivateRouteSecondaryAccounts>
                  }
                />
                <Route
                  path="/secondary-accounts-reports"
                  element={
                    <PrivateRouteSecondaryAccounts>
                      <ReportsSecondary />
                    </PrivateRouteSecondaryAccounts>
                  }
                />
                <Route
                  path="/secondary-accounts-verified-payment-class-x"
                  element={
                    <PrivateRouteSecondaryAccounts>
                      <VerifiedPaymentsSecondary10 />
                    </PrivateRouteSecondaryAccounts>
                  }
                />
                <Route
                  path="/secondary-accounts-challan-pending-submission-class-x"
                  element={
                    <PrivateRouteSecondaryAccounts>
                      <ChallanPendingSubmissionSecondary10 />
                    </PrivateRouteSecondaryAccounts>
                  }
                />
                <Route
                  path="/secondary-accounts-challan-not-generated-class-x"
                  element={
                    <PrivateRouteSecondaryAccounts>
                      <ChallanNotGeneratedSecondary10 />
                    </PrivateRouteSecondaryAccounts>
                  }
                />
                <Route
                  path="/secondary-accounts-fees-structure-class-x"
                  element={
                    <PrivateRouteSecondaryAccounts>
                      <FeesStructureSecondaryCL10 />
                    </PrivateRouteSecondaryAccounts>
                  }
                />
                <Route
                  path="*"
                  element={<Navigate to="/no-access" replace />}
                />
                <Route path="/no-access" element={<Noaccess />} />
              </>
            ) : (
              ""
            )}
            {/* Intermediate Accounts Routes */}
            {class11foactive === "ON" || class12foactive === "ON" ? (
              <>
                <Route
                  path="/intermediate-accounts"
                  element={
                    <AccountsLoginIntermediate
                      class11foroute={class11foroute}
                      setClass11foroute={setClass11foroute}
                      class12foroute={class12foroute}
                      setClass12foroute={setClass12foroute}
                    />
                  }
                />
                <Route
                  path="*"
                  element={<Navigate to="/no-access" replace />}
                />
                <Route path="/no-access" element={<Noaccess />} />
              </>
            ) : (
              ""
            )}
            {class11foactive === "ON" ? (
              <>
                <Route
                  path="/intermediate-accounts-dashboard-class-xi"
                  element={
                    <PrivateRouteItermediateAccounts>
                      <AccountsDashboardIntermediate11 />
                    </PrivateRouteItermediateAccounts>
                  }
                />
                <Route
                  path="/intermediate-accounts-payment-pending-class-xi"
                  element={
                    <PrivateRouteItermediateAccounts>
                      <PaymentPendingIntermediate11 />
                    </PrivateRouteItermediateAccounts>
                  }
                />
                <Route
                  path="/intermediate-accounts-reject-payment-class-xi"
                  element={
                    <PrivateRouteItermediateAccounts>
                      <RejectedPaymentsIntermediate11 />
                    </PrivateRouteItermediateAccounts>
                  }
                />
                <Route
                  path="/intermediate-accounts-verified-payment-class-xi"
                  element={
                    <PrivateRouteItermediateAccounts>
                      <VerifiedPaymentsIntermediate11 />
                    </PrivateRouteItermediateAccounts>
                  }
                />
                <Route
                  path="/intermediate-accounts-challan-pending-submission-class-xi"
                  element={
                    <PrivateRouteItermediateAccounts>
                      <ChallanPendingSubmissionIntermediate11 />
                    </PrivateRouteItermediateAccounts>
                  }
                />
                <Route
                  path="/intermediate-accounts-reports-class-xi"
                  element={
                    <PrivateRouteItermediateAccounts>
                      <ReportsIntermediate11 />
                    </PrivateRouteItermediateAccounts>
                  }
                />
                <Route
                  path="/intermediate-accounts-fees-structure-class-xi"
                  element={
                    <PrivateRouteItermediateAccounts>
                      <FeesStructureIntermediate11 />
                    </PrivateRouteItermediateAccounts>
                  }
                />
                <Route
                  path="*"
                  element={<Navigate to="/no-access" replace />}
                />
                <Route path="/no-access" element={<Noaccess />} />
              </>
            ) : (
              ""
            )}
            {class12foactive === "ON" ? (
              <>
                <Route
                  path="/intermediate-accounts-dashboard-class-xii"
                  element={
                    <PrivateRouteItermediateAccounts>
                      <AccountsDashboardIntermediate12 />
                    </PrivateRouteItermediateAccounts>
                  }
                />
                <Route
                  path="/intermediate-accounts-payment-pending-class-xii"
                  element={
                    <PrivateRouteItermediateAccounts>
                      <PaymentPendingIntermediate12 />
                    </PrivateRouteItermediateAccounts>
                  }
                />
                <Route
                  path="/intermediate-accounts-reject-payment-class-xii"
                  element={
                    <PrivateRouteItermediateAccounts>
                      <RejectedPaymentsIntermediate12 />
                    </PrivateRouteItermediateAccounts>
                  }
                />
                <Route
                  path="/intermediate-accounts-verified-payment-class-xii"
                  element={
                    <PrivateRouteItermediateAccounts>
                      <VerifiedPaymentsIntermediate12 />
                    </PrivateRouteItermediateAccounts>
                  }
                />
                <Route
                  path="/intermediate-accounts-challan-pending-submission-class-xii"
                  element={
                    <PrivateRouteItermediateAccounts>
                      <ChallanPendingSubmissionIntermediate12 />
                    </PrivateRouteItermediateAccounts>
                  }
                />
                <Route
                  path="/intermediate-accounts-reports-class-xii"
                  element={
                    <PrivateRouteItermediateAccounts>
                      <ReportsIntermediate12 />
                    </PrivateRouteItermediateAccounts>
                  }
                />
                <Route
                  path="/intermediate-accounts-fees-structure-class-xii"
                  element={
                    <PrivateRouteItermediateAccounts>
                      <FeesStructureIntermediate12 />
                    </PrivateRouteItermediateAccounts>
                  }
                />
                <Route
                  path="*"
                  element={<Navigate to="/no-access" replace />}
                />
                <Route path="/no-access" element={<Noaccess />} />
              </>
            ) : (
              ""
            )}
            {/* Secondary Admin Routes */}
            <>
              <Route
                path="/secondary-admin"
                element={<AdminLoginSecondary />}
              />
              <Route
                path="/secondary-admin-dashboard"
                element={<AdminDashboardSecondary />}
              />
              <Route
                path="/secondary-admin-edit-school"
                element={<EditSchoolSecondary />}
              />
              <Route
                path="/secondary-admin-add-school"
                element={<AddSchoolSecondary />}
              />
              <Route
                path="/secondary-admin-reset-deo-password"
                element={<DeoListSecondary />}
              />
              <Route
                path="/secondary-admin-school-list"
                element={<SchoolListSecondary />}
              />
              <Route
                path="/secondary-admin-ticker-master"
                element={<TickerMasterSecondary />}
              />
              <Route
                path="/secondary-admin-upload-notice-class-ix"
                element={<UploadNotice9Secondary />}
              />
              <Route
                path="/secondary-admin-upload-notice-class-x"
                element={<UploadNotice10Secondary />}
              />
              <Route
                path="/secondary-admin-class-ix-reports"
                element={<ClassixReportsSecondary />}
              />
              <Route
                path="/secondary-admin-class-x-reports"
                element={<ClassxReportsSecondary />}
              />
                    <Route
              path="/secondary-not-found-class-ix"
              element={<NotFoundList9 />}
            />
            <Route
              path="/secondary-data-not-found-class-ix"
              element={<DataNotfound9 />}
            />
                 <Route
              path="/secondary-not-found-class-x"
              element={<NotFoundList10 />}
            />
            <Route
              path="/secondary-data-not-found-class-x"
              element={<StudentDataNotfound10 />}
            />
              <Route
                path="/secondary-admin-challan-cancel-class-ix"
                element={<ChallanCancelSecondary9 />}
              />
              <Route
                path="/secondary-admin-challan-cancel-class-x"
                element={<ChallanCancelSecondary10 />}
              />
                   <Route
              path="/secondary-admin-data-not-found-class-ix"
              element={<DataNotFountListDetails9 />}
            />
            <Route
              path="/secondary-admin-data-not-found-class-x"
              element={<DataNotFountListDetails10 />}
            />
            <Route
              path="/secondary-demographic-details-update"
              element={<Studentcorrection />}
            />
            <Route
              path="/secondary-demographic-details-update-page"
              element={<StudentCorrectionPage />}
            />
              {/* <Route
                path="/secondary-admin-data-not-found-class-ix"
                element={<DataNotFoundSecondary9 />}
              /> */}
              {/* <Route
                path="/secondary-admin-data-not-found-class-x"
                element={<DataNotFoundSecondary10 />}
              /> */}
            </>
            {/* Intermediate Admin Routes */}
            <>
              <Route
                path="/intermediate-admin"
                element={<AdminLoginIntermediate />}
              />
              <Route
                path="/intermediate-admin-dashboard"
                element={<AdminDashboardIntermediate />}
              />
              <Route
                path="/intermediate-admin-add-school"
                element={<AddSchoolIntermediate />}
              />
              <Route
                path="/intermediate-admin-reset-deo-password"
                element={<DeoListIntermediate />}
              />
              <Route
                path="/intermediate-admin-intake-quota"
                element={<IntakeQuotaIntermediate />}
              />
              <Route
                path="/intermediate-admin-intake-quota-allocation"
                element={<IntakeQuotaAllocationIntermediate />}
              />
              <Route
                path="/intermediate-admin-school-list"
                element={<SchoolListIntermediate />}
              />
              <Route
                path="/intermediate-admin-edit-school"
                element={<EditSchoolIntermediate />}
              />
              <Route
                path="/intermediate-admin-add-school"
                element={<AddSchool />}
              />
              <Route
                path="/intermediate-admin-student-correction"
                element={<StudentCorrectionIntermediate />}
              />
              <Route
                path="/intermediate-admin-view-school-details"
                element={<ViewSchoolDetailsIntermediate />}
              />
              <Route
                path="/intermediate-admin-ticker-master"
                element={<TickerMasterIntermediate />}
              />
              <Route
                path="/intermediate-admin-upload-notice-class-xi"
                element={<UploadNoticeIntermediate11 />}
              />
              <Route
                path="/intermediate-admin-upload-notice-class-xii"
                element={<UploadNoticeIntermediate12 />}
              />
              <Route
                path="/intermediate-admin-class-xi-reports"
                element={<ClassxiReportsIntermediate />}
              />
              <Route
                path="/intermediate-admin-class-xii-reports"
                element={<ClassxiiReportsIntermediate />}
              />
              <Route
                path="/intermediate-admin-challan-cancel-class-xi"
                element={<ChallanCancelIntermediate11 />}
              />
              <Route
                path="/intermediate-admin-challan-cancel-class-xii"
                element={<ChallanCancelIntermediate12 />}
              />
                   <Route
              path="/intermediate-not-found-class-xi"
              element={<NotFoundList11 />}
            />
            <Route
              path="/intermediate-not-found-class-xii"
              element={<NotFoundList12 />}
            />
            <Route
              path="/intermediate-data-not-found-class-xi"
              element={<DataNotfoundListInter11 />}
            />
            <Route
              path="/intermediate-data-not-found-class-xii"
              element={<DataNotfoundListInter12 />}
            />
            <Route
              path="/intermediate-admin-data-not-found-class-xii"
              element={<DataNotFountListDetails12 />}
            />
            <Route
              path="/intermediate-admin-data-not-found-class-xi"
              element={<DataNotFountListDetails11 />}
            />
            <Route
              path="/intermediate-demographic-details-update"
              element={<Studentcorrection11 />}
            />
            <Route
              path="/intermediate-demographic-details-update-page"
              element={<StudentCorrectionPage11 />}
            />
              {/* <Route
                path="/intermediate-admin-data-not-found-class-xi"
                element={<DataNotFoundIntermediate11 />}
              />
              <Route
                path="/intermediate-admin-data-not-found-class-xii"
                element={<DataNotFoundIntermediate12 />}
              /> */}
            </>
          </Routes>
        </Router>
      ) : (
        config.BASE_URL_ON_OFF === "ON" ? (
          <Router basename={activeBaseUrl}>
            <DynamicTitle />
            <Routes>
              {class9active === "ACTIVE" && config.BASE_URL_1_STATUS === "ON" ? (
                <>
                  <Route
                    path="/"
                    element={
                      <Login
                        setClass9Route={setClass9Route}
                        class9Route={class9Route}
                      />
                    }
                  />

                  <Route
                    path="/backdoor-login-cl-9"
                    element={<BackdoorLogin />}
                  />
                  <Route
                    path="/class-ix-dashboard"
                    element={
                      <PrivateRoute>
                        <Dashboard />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-school-profile"
                    element={
                      <PrivateRoute>
                        <Schoolprofile />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-total-registration"
                    element={
                      <PrivateRoute>
                        <TotalRegistration />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-checklist-generated"
                    element={
                      <PrivateRoute>
                        <Checklistgenerated />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-deo-pending"
                    element={
                      <PrivateRoute>
                        <Pendingdeo />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-deo-approve"
                    element={
                      <PrivateRoute>
                        <Approveddeo />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-deo-reject"
                    element={
                      <PrivateRoute>
                        <Rejectdeo />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-generate-challan"
                    element={
                      <PrivateRoute>
                        <GenerateChallan />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-challan-status"
                    element={
                      <PrivateRoute>
                        <Challanstatus />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-consolidated-checklist"
                    element={
                      <PrivateRoute>
                        <Consolidatedchecklist />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-checklist"
                    element={
                      <PrivateRoute>
                        <Checklist />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-regular-student"
                    element={
                      <PrivateRoute>
                        <Addstudentregular />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-ex-regular-student"
                    element={
                      <PrivateRoute>
                        <Exregularfirst />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-add-ex-regular-student"
                    element={
                      <PrivateRoute>
                        <Exregularsecond />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-upload-document"
                    element={
                      <PrivateRoute>
                        <Document />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-data-not-found"
                    element={
                      <PrivateRoute>
                        <DataNotFound />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-data-not-found-list"
                    element={
                      <PrivateRoute>
                        <DataNotFoundList />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/generate-pdf-class-ix"
                    element={<GeneratePDFIX />}
                  />
                  <Route
                    path="/list-of-examinees-cl-9"
                    element={<ListofExamineesPDF />}
                  />
  <Route
                path="/class-ix-correct-student"
                element={
                  <PrivateRoute>
                    <CorrectStudentPage9 />
                  </PrivateRoute>
                }
              />
              <Route
                path="/class-ix-correct-ex-student"
                element={
                  <PrivateRoute>
                    <CorrectStudentExregular9 />
                  </PrivateRoute>
                }
              />
              <Route
                path="/class-ix-correct-student-regular"
                element={
                  <PrivateRoute>
                    <CorrectStudentRegular9 />
                  </PrivateRoute>
                }
              />
                  <Route
                    path="*"
                    element={<Navigate to="/no-access" replace />}
                  />
                  <Route path="/no-access" element={<Noaccess />} />
                </>
              ) : (
                ""
              )}
              {class10active === "ACTIVE" && config.BASE_URL_2_STATUS === "ON" ? (
                <>
                  <Route path="/" element={<Navigate to="/class-x" replace />} />
                  <Route
                    path="/class-x"
                    element={
                      <Login10
                        setClass10Route={setClass10Route}
                        class10Route={class10Route}
                      />
                    }
                  />
                  <Route
                    path="/backdoor-login-cl-10"
                    element={
                      <BackdoorLogin10
                        setClass10Route={setClass10Route}
                        class10Route={class10Route}
                      />
                    }
                  />
                  <Route
                    path="/class-x-dashboard"
                    element={
                      <PrivateRoute10>
                        <Dashboard10 />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-school-profile"
                    element={
                      <PrivateRoute10>
                        <Schoolprofile10 />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-total-registration"
                    element={
                      <PrivateRoute10>
                        <TotalRegistration10 />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-generate-challan"
                    element={
                      <PrivateRoute10>
                        <GenerateChallan10 />
                      </PrivateRoute10>
                    }
                  />
                    <Route
                path="/class-x-backdoor-generate-challan"
                element={
                  <PrivateRoute10>
                    <GenerateChallanLateral10 /> 
                  </PrivateRoute10>
                }
              />
                  <Route
                    path="/class-x-challan-status"
                    element={
                      <PrivateRoute10>
                        <Challanstatus10 />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-consolidated-checklist"
                    element={
                      <PrivateRoute10>
                        <Consolidatedchecklist10 />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-regular-student"
                    element={
                      <PrivateRoute10>
                        <Addstudentregular10 />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-checklist-generated"
                    element={
                      <PrivateRoute10>
                        <Checklistgenerated10 />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-ex-regular-student"
                    element={
                      <PrivateRoute10>
                        <Exregularfirst10 />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-add-ex-regular-student"
                    element={
                      <PrivateRoute10>
                        <Exregularsecond10 />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-improvement-student"
                    element={
                      <PrivateRoute10>
                        <Improvementfirst />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-improvement-info"
                    element={
                      <PrivateRoute10>
                        <Improvementsecond />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-regular-student-info"
                    element={
                      <PrivateRoute10>
                        <Addstudentregularsecond />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-upload-document"
                    element={
                      <PrivateRoute10>
                        <Document10 />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-data-not-found"
                    element={
                      <PrivateRoute10>
                        <DataNotFound10 />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-data-not-found-list"
                    element={
                      <PrivateRoute10>
                        <DataNotFoundList10 />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/generate-pdf-class-x"
                    element={<GeneratePDFX10 />}
                  />
                  <Route
                    path="/list-of-examinees-cl-10"
                    element={<ListofExamineesPDF10 />}
                  />
                   <Route
                path="/class-x-correct-student"
                element={
                  <PrivateRoute10>
                    <CorrectStudentPage1 />           
                  </PrivateRoute10>
                }
              />
              <Route
                path="/class-x-correction-regular"
                element={
                  <PrivateRoute10>
                    <CorrectionRegular />
                  </PrivateRoute10>
                }
              />
              <Route
                path="/class-x-correction-exregular"
                element={
                  <PrivateRoute10>
                    <CorrectExregular />
                  </PrivateRoute10>
                }
              />
              <Route
                path="/class-x-correction-improvement"
                element={
                  <PrivateRoute10>
                    <CorrectImprovement />
                  </PrivateRoute10>
                }
              />
                  <Route
                    path="*"
                    element={<Navigate to="/no-access" replace />}
                  />
                  <Route path="/no-access" element={<Noaccess />} />
                </>
              ) : (
                ""
              )}
              {class11active === "ACTIVE" && config.BASE_URL_3_STATUS === "ON" ? (
                <>
                  <Route path="/" element={<Navigate to="/class-xi" replace />} />
                  <Route
                    path="/class-xi"
                    element={
                      <Login11
                        setClass11Route={setClass11Route}
                        class11Route={class11Route}
                      />
                    }
                  />
                  <Route
                    path="/backdoor-login-cl-11"
                    element={<BackdoorLogin11 />}
                  />
                  <Route
                    path="/class-xi-dashboard"
                    element={
                      <PrivateRoute11>
                        <Dashboard11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/class-xi-school-profile"
                    element={
                      <PrivateRoute11>
                        <Schoolprofile11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/class-xi-add-student-jac"
                    element={
                      <PrivateRoute11>
                        <Addjacstudent11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/class-xi-add-student-jac-page"
                    element={
                      <PrivateRoute11>
                        <Addjacstudent11page2 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/class-xi-add-others-student"
                    element={
                      <PrivateRoute11>
                        <Addstudentothers11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/class-xi-add-ex-regular-jac"
                    element={
                      <PrivateRoute11>
                        <Addexregular11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/class-xi-add-ex-regular-info-jac"
                    element={
                      <PrivateRoute11>
                        <Addexregularsecond11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/class-xi-board-registration"
                    element={
                      <PrivateRoute11>
                        <Board2020registration />
                      </PrivateRoute11>
                    }
                  />

                  <Route
                    path="/class-xi-total-registration"
                    element={
                      <PrivateRoute11>
                        <TotalRegistration11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/class-xi-checklist-generated"
                    element={
                      <PrivateRoute11>
                        <Checklistgenerated11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/class-xi-generate-challan"
                    element={
                      <PrivateRoute11>
                        <GenerateChallan11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/generate-pdf-class-xi"
                    element={
                      <PrivateRoute11>
                        <GeneratePDFXI />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/class-xi-challan-status"
                    element={
                      <PrivateRoute11>
                        <Challanstatus11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/class-xi-consolidated-checklist"
                    element={
                      <PrivateRoute11>
                        <Consolidatedchecklist11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/class-xi-upload-document"
                    element={
                      <PrivateRoute11>
                        <Document11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/list-of-examinees-cl-11"
                    element={<ListofExamineesPDF11 />}
                  />
                  <Route
                    path="/class-xi-data-not-found"
                    element={
                      <PrivateRoute11>
                        <DataNotFound11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/class-xi-data-not-found-list"
                    element={
                      <PrivateRoute11>
                        <DataNotFoundList11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                path="/class-xi-correct-student"
                element={
                  // <PrivateRoute11>
                  <CorrectStudent11 />
                  // </PrivateRoute11>
                }
              />
              <Route
                path="/class-xi-correction-regular"
                element={
                  //<PrivateRoute11>
                  <CorrectStudentJac11 />
                  // </PrivateRoute11>
                }
              />
              <Route
                path="/class-xi-correction-exregular"
                element={
                  // <PrivateRoute11>
                  <CorrectStudentExregular11 />
                  // </PrivateRoute11>
                }
              />
              <Route
                path="/class-xi-correction-others"
                element={
                  // <PrivateRoute11>
                  <CorrectStudentOthers11 />
                  // </PrivateRoute11>
                }
              />
              <Route
                path="/class-xi-correction-board-registration"
                element={
                  // <PrivateRoute11>
                  <CorrectStudentBeforeStudent11 />
                  // </PrivateRoute11>
                }
              />
                  <Route
                    path="*"
                    element={<Navigate to="/no-access" replace />}
                  />
                  <Route path="/no-access" element={<Noaccess />} />
                </>
              ) : (
                ""
              )}
              {class12active === "ACTIVE" && config.BASE_URL_4_STATUS === "ON" ? (
                <>
                  <Route
                    path="/"
                    element={<Navigate to="/class-xii" replace />}
                  />
                  <Route
                    path="/class-xii"
                    element={
                      <Login12
                        setClass12Route={setClass12Route}
                        class12Route={class12Route}
                      />
                    }
                  />
                  <Route
                    path="/backdoor-login-cl-12"
                    element={<BackdoorLogin12 />}
                  />
                  <Route
                    path="/class-xii-dashboard"
                    element={
                      <PrivateRoute12>
                        <Dashboard12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-school-profile"
                    element={
                      <PrivateRoute12>
                        <Schoolprofile12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-total-registration"
                    element={
                      <PrivateRoute12>
                        <TotalRegistration12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-checklist-generated"
                    element={
                      <PrivateRoute12>
                        <Checklistgenerated12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-generate-challan"
                    element={
                      <PrivateRoute12>
                        <GenerateChallan12 />
                      </PrivateRoute12>
                    }
                  />
                   <Route
                path="/class-xii-backdoor-generate-challan"
                element={
                  <PrivateRoute12>
                    <GenerateLateralChallan12 />
                  </PrivateRoute12>
                }
              />
              
                  <Route
                    path="/class-xii-challan-status"
                    element={
                      <PrivateRoute12>
                        <Challanstatus12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-consolidated-checklist"
                    element={
                      <PrivateRoute12>
                        <Consolidatedchecklist12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-add-ex-regular-jac"
                    element={
                      <PrivateRoute12>
                        <Addexregular12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-add-ex-regular-info-jac"
                    element={
                      <PrivateRoute12>
                        <Addexregularsecond12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-add-improvement-jac"
                    element={
                      <PrivateRoute12>
                        <Addimprovement12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-add-improvement-info"
                    element={
                      <PrivateRoute12>
                        <Addimprovementsecond12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/generate-pdf-class-xii"
                    element={
                      // <PrivateRoute12>
                      <GeneratePDFXII />
                      // </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-add-qualifying-jac"
                    element={
                      <PrivateRoute12>
                        <Addqualifying12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-add-qualifying-info"
                    element={
                      <PrivateRoute12>
                        <Addqualifyingsecond12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-add-regular-jac"
                    element={
                      <PrivateRoute12>
                        <Addstudentregular12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-regular-student-info"
                    element={
                      <PrivateRoute12>
                        <Addstudentregularsecond12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-upload-document"
                    element={
                      <PrivateRoute12>
                        <Document12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/list-of-examinees-cl-12"
                    element={<ListofExamineesPDF12 />}
                  />
                  <Route
                    path="/class-xii-data-not-found"
                    element={
                      <PrivateRoute12>
                        <DataNotFound12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-data-not-found-list"
                    element={
                      <PrivateRoute12>
                        <DataNotFoundList12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                path="/class-xii-correct-student"
                element={
                  <PrivateRoute12>
                    <CorrectStudent12 />
                  </PrivateRoute12>
                }
              />
              <Route
                path="/class-xii-correction-regular"
                element={
                  <PrivateRoute12>
                    <CorrectRegular12 />
                  </PrivateRoute12>
                }
              />
              <Route
                path="/class-xii-correction-exregular"
                element={
                  <PrivateRoute12>
                    <CorrectExregular12 />
                  </PrivateRoute12>
                }
              />
              <Route
                path="/class-xii-correction-betterment"
                element={
                  <PrivateRoute12>
                    <CorrectBetterment12 />
                  </PrivateRoute12>
                }
              />
              <Route
                path="/class-xii-correction-qualify"
                element={
                  <PrivateRoute12>
                    <CorrectQualify12 />
                  </PrivateRoute12>
                }
              />
                  <Route
                    path="*"
                    element={<Navigate to="/no-access" replace />}
                  />
                  <Route path="/no-access" element={<Noaccess />} />
                </>
              ) : (
                ""
              )}
              {class9deoactive === "ON" && config.BASE_URL_1_STATUS === "ON" ? (
                <>
                  <Route
                    path="/deo"
                    element={
                      <DEOlogin
                        setClass9deoroute={setClass9deoroute}
                        class9deoroute={class9deoroute}
                      />
                    }
                  />
                  <Route
                    path="/deo-backdoor-login"
                    element={
                      <DEObackdoorLogin
                        setClass9deoroute={setClass9deoroute}
                        class9deoroute={class9deoroute}
                      />
                    }
                  />
                  <Route
                    path="/deo-dashboard"
                    element={
                      <PrivateRouteDeo>
                        <DEOdashboard />
                      </PrivateRouteDeo>
                    }
                  />
                  <Route
                    path="/deo-pending-for-approval"
                    element={
                      <PrivateRouteDeo>
                        <Pendingforapproval />
                      </PrivateRouteDeo>
                    }
                  />
                  <Route
                    path="/deo-total-approved"
                    element={
                      <PrivateRouteDeo>
                        <Totalapproved />
                      </PrivateRouteDeo>
                    }
                  />
                  <Route
                    path="/deo-rejected"
                    element={
                      <PrivateRouteDeo>
                        <DEOrejected />
                      </PrivateRouteDeo>
                    }
                  />
                  <Route
                    path="/total-schools"
                    element={
                      <PrivateRouteDeo>
                        <Totalschools />
                      </PrivateRouteDeo>
                    }
                  />

                  <Route
                    path="/initiate-verification"
                    element={<Initiateverification />}
                  />
                  <Route
                    path="/total-approved-applicant"
                    element={
                      // <PrivateRouteDeo>
                      <TotalApprovedApplicant />
                      //  </PrivateRouteDeo>
                    }
                  />
                  <Route
                    path="/total-rejected-applicant"
                    element={
                      // <PrivateRouteDeo>
                      <TotalRejectedApplicant />
                      //   </PrivateRouteDeo>
                    }
                  />
                  <Route
                    path="/total-pending-applicant"
                    element={
                      // <PrivateRouteDeo>
                      <PendingApplicantsPage />
                      //  </PrivateRouteDeo>
                    }
                  />
                  <Route
                    path="/total-applicant"
                    element={
                      // <PrivateRouteDeo>
                      <TotalApplicant />
                      // </PrivateRouteDeo>
                    }
                  />
                  <Route
                    path="*"
                    element={<Navigate to="/no-access" replace />}
                  />
                  <Route path="/no-access" element={<Noaccess />} />
                </>
              ) : (
                ""
              )}
            </Routes>
          </Router>
        ) : (
          <Router>
            <DynamicTitle />
            <Routes>
              <Route path="/Secondary" element={<SecondaryLanding />} />
              <Route path="/Intermediate" element={<IntermediateLanding />} />
              {/* <Route path="/no-access" element={<BonManus />} /> */}
              {/* <Route path="/no-access" element={<Noaccess />} /> */}

              {/* Class 9 Route start */}
              {class9active === "ACTIVE" ? (
                <>
                  <Route
                    path="/"
                    element={
                      <Login
                        setClass9Route={setClass9Route}
                        class9Route={class9Route}
                      />
                    }
                  />

                  <Route path="/backdoor-login-cl-9" element={<BackdoorLogin />} />
                  <Route
                    path="/class-ix-dashboard"
                    element={
                      <PrivateRoute>
                        <Dashboard />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-school-profile"
                    element={
                      <PrivateRoute>
                        <Schoolprofile />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-total-registration"
                    element={
                      <PrivateRoute>
                        <TotalRegistration />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-checklist-generated"
                    element={
                      <PrivateRoute>
                        <Checklistgenerated />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-deo-pending"
                    element={
                      <PrivateRoute>
                        <Pendingdeo />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-deo-approve"
                    element={
                      <PrivateRoute>
                        <Approveddeo />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-deo-reject"
                    element={
                      <PrivateRoute>
                        <Rejectdeo />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-generate-challan"
                    element={
                      <PrivateRoute>
                        <GenerateChallan />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-challan-status"
                    element={
                      <PrivateRoute>
                        <Challanstatus />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-consolidated-checklist"
                    element={
                      <PrivateRoute>
                        <Consolidatedchecklist />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-checklist"
                    element={
                      <PrivateRoute>
                        <Checklist />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-regular-student"
                    element={
                      <PrivateRoute>
                        <Addstudentregular />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-ex-regular-student"
                    element={
                      <PrivateRoute>
                        <Exregularfirst />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-add-ex-regular-student"
                    element={
                      <PrivateRoute>
                        <Exregularsecond />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-upload-document"
                    element={
                      <PrivateRoute>
                        <Document />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-data-not-found"
                    element={
                      <PrivateRoute>
                        <DataNotFound />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/class-ix-data-not-found-list"
                    element={
                      <PrivateRoute>
                        <DataNotFoundList />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/generate-pdf-class-ix"
                    element={<GeneratePDFIX />}
                  />
                  <Route
                    path="/list-of-examinees-cl-9"
                    element={<ListofExamineesPDF />}
                  />

                  <Route path="*" element={<Navigate to="/no-access" replace />} />
                  <Route path="/no-access" element={<Noaccess />} />
                </>
              ) : (
                ""
              )}
              {/* Class 10 Route start */}
              {class10active === "ACTIVE" ? (
                <>
                  <Route
                    path="/class-x"
                    element={
                      <Login10
                        setClass10Route={setClass10Route}
                        class10Route={class10Route}
                      />
                    }
                  />
                  <Route
                    path="/backdoor-login-cl-10"
                    element={
                      <BackdoorLogin10
                        setClass10Route={setClass10Route}
                        class10Route={class10Route}
                      />
                    }
                  />
                  <Route
                    path="/class-x-dashboard"
                    element={
                      <PrivateRoute10>
                        <Dashboard10 />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-school-profile"
                    element={
                      <PrivateRoute10>
                        <Schoolprofile10 />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-total-registration"
                    element={
                      <PrivateRoute10>
                        <TotalRegistration10 />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-generate-challan"
                    element={
                      <PrivateRoute10>
                        <GenerateChallan10 />
                      </PrivateRoute10>
                    }
                  />
                    <Route
                path="/class-x-backdoor-generate-challan"
                element={
                  <PrivateRoute10>
                    <GenerateChallanLateral10 /> 
                  </PrivateRoute10>
                }
              />
                  <Route
                    path="/class-x-challan-status"
                    element={
                      <PrivateRoute10>
                        <Challanstatus10 />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-consolidated-checklist"
                    element={
                      <PrivateRoute10>
                        <Consolidatedchecklist10 />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-regular-student"
                    element={
                      <PrivateRoute10>
                        <Addstudentregular10 />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-checklist-generated"
                    element={
                      <PrivateRoute10>
                        <Checklistgenerated10 />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-ex-regular-student"
                    element={
                      <PrivateRoute10>
                        <Exregularfirst10 />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-add-ex-regular-student"
                    element={
                      <PrivateRoute10>
                        <Exregularsecond10 />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-improvement-student"
                    element={
                      <PrivateRoute10>
                        <Improvementfirst />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-improvement-info"
                    element={
                      <PrivateRoute10>
                        <Improvementsecond />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-regular-student-info"
                    element={
                      <PrivateRoute10>
                        <Addstudentregularsecond />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-upload-document"
                    element={
                      <PrivateRoute10>
                        <Document10 />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-data-not-found"
                    element={
                      <PrivateRoute10>
                        <DataNotFound10 />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/class-x-data-not-found-list"
                    element={
                      <PrivateRoute10>
                        <DataNotFoundList10 />
                      </PrivateRoute10>
                    }
                  />
                  <Route
                    path="/generate-pdf-class-x"
                    element={<GeneratePDFX10 />}
                  />
                  <Route
                    path="/list-of-examinees-cl-10"
                    element={<ListofExamineesPDF10 />}
                  />
                  <Route path="*" element={<Navigate to="/no-access" replace />} />
                  <Route path="/no-access" element={<Noaccess />} />
                </>
              ) : (
                ""
              )}
              {/* Class 11 Route start */}
              {class11active === "ACTIVE" ? (
                <>
                  <Route
                    path="/class-xi"
                    element={
                      <Login11
                        setClass11Route={setClass11Route}
                        class11Route={class11Route}
                      />
                    }
                  />
                  <Route
                    path="/backdoor-login-cl-11"
                    element={<BackdoorLogin11 />}
                  />
                  <Route
                    path="/class-xi-dashboard"
                    element={
                      <PrivateRoute11>
                        <Dashboard11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/class-xi-school-profile"
                    element={
                      <PrivateRoute11>
                        <Schoolprofile11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/class-xi-add-student-jac"
                    element={
                      <PrivateRoute11>
                        <Addjacstudent11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/class-xi-add-student-jac-page"
                    element={
                      <PrivateRoute11>
                        <Addjacstudent11page2 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/class-xi-add-others-student"
                    element={
                      <PrivateRoute11>
                        <Addstudentothers11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/class-xi-add-ex-regular-jac"
                    element={
                      <PrivateRoute11>
                        <Addexregular11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/class-xi-add-ex-regular-info-jac"
                    element={
                      <PrivateRoute11>
                        <Addexregularsecond11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/class-xi-board-registration"
                    element={
                      <PrivateRoute11>
                        <Board2020registration />
                      </PrivateRoute11>
                    }
                  />

                  <Route
                    path="/class-xi-total-registration"
                    element={
                      <PrivateRoute11>
                        <TotalRegistration11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/class-xi-checklist-generated"
                    element={
                      <PrivateRoute11>
                        <Checklistgenerated11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/class-xi-generate-challan"
                    element={
                      <PrivateRoute11>
                        <GenerateChallan11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/generate-pdf-class-xi"
                    element={
                      <PrivateRoute11>
                        <GeneratePDFXI />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/class-xi-challan-status"
                    element={
                      <PrivateRoute11>
                        <Challanstatus11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/class-xi-consolidated-checklist"
                    element={
                      <PrivateRoute11>
                        <Consolidatedchecklist11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/class-xi-upload-document"
                    element={
                      <PrivateRoute11>
                        <Document11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/list-of-examinees-cl-11"
                    element={<ListofExamineesPDF11 />}
                  />
                  <Route
                    path="/class-xi-data-not-found"
                    element={
                      <PrivateRoute11>
                        <DataNotFound11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route
                    path="/class-xi-data-not-found-list"
                    element={
                      <PrivateRoute11>
                        <DataNotFoundList11 />
                      </PrivateRoute11>
                    }
                  />
                  <Route path="*" element={<Navigate to="/no-access" replace />} />
                  <Route path="/no-access" element={<Noaccess />} />
                </>
              ) : (
                ""
              )}

              {class12active === "ACTIVE" ? (
                <>
                  <Route
                    path="/class-xii"
                    element={
                      <Login12
                        setClass12Route={setClass12Route}
                        class12Route={class12Route}
                      />
                    }
                  />
                  <Route
                    path="/backdoor-login-cl-12"
                    element={<BackdoorLogin12 />}
                  />
                  <Route
                    path="/class-xii-dashboard"
                    element={
                      <PrivateRoute12>
                        <Dashboard12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-school-profile"
                    element={
                      <PrivateRoute12>
                        <Schoolprofile12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-total-registration"
                    element={
                      <PrivateRoute12>
                        <TotalRegistration12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-checklist-generated"
                    element={
                      <PrivateRoute12>
                        <Checklistgenerated12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-generate-challan"
                    element={
                      <PrivateRoute12>
                        <GenerateChallan12 />
                      </PrivateRoute12>
                    }
                  />
                   <Route
                path="/class-xii-backdoor-generate-challan"
                element={
                  <PrivateRoute12>
                     <GenerateLateralChallan12 />
                  </PrivateRoute12>
                }
              />
              
                  <Route
                    path="/class-xii-challan-status"
                    element={
                      <PrivateRoute12>
                        <Challanstatus12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-consolidated-checklist"
                    element={
                      <PrivateRoute12>
                        <Consolidatedchecklist12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-add-ex-regular-jac"
                    element={
                      <PrivateRoute12>
                        <Addexregular12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-add-ex-regular-info-jac"
                    element={
                      <PrivateRoute12>
                        <Addexregularsecond12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-add-improvement-jac"
                    element={
                      <PrivateRoute12>
                        <Addimprovement12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-add-improvement-info"
                    element={
                      <PrivateRoute12>
                        <Addimprovementsecond12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/generate-pdf-class-xii"
                    element={
                      // <PrivateRoute12>
                      <GeneratePDFXII />
                      // </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-add-qualifying-jac"
                    element={
                      <PrivateRoute12>
                        <Addqualifying12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-add-qualifying-info"
                    element={
                      <PrivateRoute12>
                        <Addqualifyingsecond12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-add-regular-jac"
                    element={
                      <PrivateRoute12>
                        <Addstudentregular12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-regular-student-info"
                    element={
                      <PrivateRoute12>
                        <Addstudentregularsecond12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-upload-document"
                    element={
                      <PrivateRoute12>
                        <Document12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/list-of-examinees-cl-12"
                    element={<ListofExamineesPDF12 />}
                  />
                  <Route
                    path="/class-xii-data-not-found"
                    element={
                      <PrivateRoute12>
                        <DataNotFound12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route
                    path="/class-xii-data-not-found-list"
                    element={
                      <PrivateRoute12>
                        <DataNotFoundList12 />
                      </PrivateRoute12>
                    }
                  />
                  <Route path="*" element={<Navigate to="/no-access" replace />} />
                  <Route path="/no-access" element={<Noaccess />} />
                </>
              ) : (
                ""
              )}
              {/* DEO Route */}
              {class9deoactive === "ON" ? (
                <>
                  <Route
                    path="/deo"
                    element={
                      <DEOlogin
                        setClass9deoroute={setClass9deoroute}
                        class9deoroute={class9deoroute}
                      />
                    }
                  />
                  <Route
                    path="/deo-backdoor-login"
                    element={
                      <DEObackdoorLogin
                        setClass9deoroute={setClass9deoroute}
                        class9deoroute={class9deoroute}
                      />
                    }
                  />
                  <Route
                    path="/deo-dashboard"
                    element={
                      <PrivateRouteDeo>
                        <DEOdashboard />
                      </PrivateRouteDeo>
                    }
                  />
                  <Route
                    path="/deo-pending-for-approval"
                    element={
                      <PrivateRouteDeo>
                        <Pendingforapproval />
                      </PrivateRouteDeo>
                    }
                  />
                  <Route
                    path="/deo-total-approved"
                    element={
                      <PrivateRouteDeo>
                        <Totalapproved />
                      </PrivateRouteDeo>
                    }
                  />
                  <Route
                    path="/deo-rejected"
                    element={
                      <PrivateRouteDeo>
                        <DEOrejected />
                      </PrivateRouteDeo>
                    }
                  />
                  <Route
                    path="/total-schools"
                    element={
                      <PrivateRouteDeo>
                        <Totalschools />
                      </PrivateRouteDeo>
                    }
                  />

                  <Route
                    path="/initiate-verification"
                    element={<Initiateverification />}
                  />
                  <Route
                    path="/total-approved-applicant"
                    element={
                      // <PrivateRouteDeo>
                      <TotalApprovedApplicant />
                      //  </PrivateRouteDeo>
                    }
                  />
                  <Route
                    path="/total-rejected-applicant"
                    element={
                      // <PrivateRouteDeo>
                      <TotalRejectedApplicant />
                      //   </PrivateRouteDeo>
                    }
                  />
                  <Route
                    path="/total-pending-applicant"
                    element={
                      // <PrivateRouteDeo>
                      <PendingApplicantsPage />
                      //  </PrivateRouteDeo>
                    }
                  />
                  <Route
                    path="/total-applicant"
                    element={
                      // <PrivateRouteDeo>
                      <TotalApplicant />
                      // </PrivateRouteDeo>
                    }
                  />
                  <Route path="*" element={<Navigate to="/no-access" replace />} />
                  <Route path="/no-access" element={<Noaccess />} />
                </>
              ) : (
                ""
              )}

              {/* Secondary Accounts Routes */}
              {class9foactive === "ON" || class10foactive === "ON" ? (
                <>
                  <Route
                    path="/secondary-accounts"
                    element={
                      <AccountsLoginSecondary
                        class9foroute={class9foroute}
                        setClass9foroute={setClass9foroute}
                        class10foroute={class10foroute}
                        setClass10foroute={setClass10foroute}
                      />
                    }
                  />
                  <Route path="*" element={<Navigate to="/no-access" replace />} />
                  <Route path="/no-access" element={<Noaccess />} />
                </>
              ) : (
                ""
              )}
              {class9foactive === "ON" ? (
                <>
                  <Route
                    path="/secondary-accounts-dashboard-class-ix"
                    element={
                      <PrivateRouteSecondaryAccounts>
                        <AccountsDashboardSecondary9 />
                      </PrivateRouteSecondaryAccounts>
                    }
                  />
                  <Route
                    path="/secondary-accounts-payment-pending-class-ix"
                    element={
                      <PrivateRouteSecondaryAccounts>
                        <PaymentPendingSecondary9 />
                      </PrivateRouteSecondaryAccounts>
                    }
                  />
                  <Route
                    path="/secondary-accounts-reject-payment-class-ix"
                    element={
                      <PrivateRouteSecondaryAccounts>
                        <RejectedPaymentsSecondary9 />
                      </PrivateRouteSecondaryAccounts>
                    }
                  />
                  <Route
                    path="/secondary-accounts-reports"
                    element={
                      <PrivateRouteSecondaryAccounts>
                        <ReportsSecondary />
                      </PrivateRouteSecondaryAccounts>
                    }
                  />
                  <Route
                    path="/secondary-accounts-verified-payment-class-ix"
                    element={
                      <PrivateRouteSecondaryAccounts>
                        <VerifiedPaymentsSecondary9 />
                      </PrivateRouteSecondaryAccounts>
                    }
                  />
                  <Route
                    path="/secondary-accounts-challan-pending-submission-class-ix"
                    element={
                      <PrivateRouteSecondaryAccounts>
                        <ChallanPendingSubmissionSecondary9 />
                      </PrivateRouteSecondaryAccounts>
                    }
                  />
                  <Route
                    path="/secondary-accounts-challan-not-generated-class-ix"
                    element={
                      <PrivateRouteSecondaryAccounts>
                        <ChallanNotGeneratedSecondary9 />
                      </PrivateRouteSecondaryAccounts>
                    }
                  />
                  <Route
                    path="/secondary-accounts-fees-structure-class-ix"
                    element={
                      <PrivateRouteSecondaryAccounts>
                        <FeesStructureSecondaryCL9 />
                      </PrivateRouteSecondaryAccounts>
                    }
                  />
                  <Route path="*" element={<Navigate to="/no-access" replace />} />
                  <Route path="/no-access" element={<Noaccess />} />
                </>
              ) : (
                ""
              )}
              {class10foactive === "ON" ? (
                <>
                  <Route
                    path="/secondary-accounts-dashboard-class-x"
                    element={
                      <PrivateRouteSecondaryAccounts>
                        <AccountsDashboardSecondary10 />
                      </PrivateRouteSecondaryAccounts>
                    }
                  />
                  <Route
                    path="/secondary-accounts-payment-pending-class-x"
                    element={
                      <PrivateRouteSecondaryAccounts>
                        <PaymentPendingSecondary10 />
                      </PrivateRouteSecondaryAccounts>
                    }
                  />
                  <Route
                    path="/secondary-accounts-reject-payment-class-x"
                    element={
                      <PrivateRouteSecondaryAccounts>
                        <RejectedPaymentsSecondary10 />
                      </PrivateRouteSecondaryAccounts>
                    }
                  />
                  <Route
                    path="/secondary-accounts-reports"
                    element={
                      <PrivateRouteSecondaryAccounts>
                        <ReportsSecondary />
                      </PrivateRouteSecondaryAccounts>
                    }
                  />
                  <Route
                    path="/secondary-accounts-verified-payment-class-x"
                    element={
                      <PrivateRouteSecondaryAccounts>
                        <VerifiedPaymentsSecondary10 />
                      </PrivateRouteSecondaryAccounts>
                    }
                  />
                  <Route
                    path="/secondary-accounts-challan-pending-submission-class-x"
                    element={
                      <PrivateRouteSecondaryAccounts>
                        <ChallanPendingSubmissionSecondary10 />
                      </PrivateRouteSecondaryAccounts>
                    }
                  />
                  <Route
                    path="/secondary-accounts-challan-not-generated-class-x"
                    element={
                      <PrivateRouteSecondaryAccounts>
                        <ChallanNotGeneratedSecondary10 />
                      </PrivateRouteSecondaryAccounts>
                    }
                  />
                  <Route
                    path="/secondary-accounts-fees-structure-class-x"
                    element={
                      <PrivateRouteSecondaryAccounts>
                        <FeesStructureSecondaryCL10 />
                      </PrivateRouteSecondaryAccounts>
                    }
                  />
                  <Route path="*" element={<Navigate to="/no-access" replace />} />
                  <Route path="/no-access" element={<Noaccess />} />
                </>
              ) : (
                ""
              )}
              {/* Intermediate Accounts Routes */}
              {class11foactive === "ON" || class12foactive === "ON" ? (
                <>
                  <Route
                    path="/intermediate-accounts"
                    element={
                      <AccountsLoginIntermediate
                        class11foroute={class11foroute}
                        setClass11foroute={setClass11foroute}
                        class12foroute={class12foroute}
                        setClass12foroute={setClass12foroute}
                      />
                    }
                  />
                  <Route path="*" element={<Navigate to="/no-access" replace />} />
                  <Route path="/no-access" element={<Noaccess />} />
                </>
              ) : (
                ""
              )}
              {class11foactive === "ON" ? (
                <>
                  <Route
                    path="/intermediate-accounts-dashboard-class-xi"
                    element={
                      <PrivateRouteItermediateAccounts>
                        <AccountsDashboardIntermediate11 />
                      </PrivateRouteItermediateAccounts>
                    }
                  />
                  <Route
                    path="/intermediate-accounts-payment-pending-class-xi"
                    element={
                      <PrivateRouteItermediateAccounts>
                        <PaymentPendingIntermediate11 />
                      </PrivateRouteItermediateAccounts>
                    }
                  />
                  <Route
                    path="/intermediate-accounts-reject-payment-class-xi"
                    element={
                      <PrivateRouteItermediateAccounts>
                        <RejectedPaymentsIntermediate11 />
                      </PrivateRouteItermediateAccounts>
                    }
                  />
                  <Route
                    path="/intermediate-accounts-verified-payment-class-xi"
                    element={
                      <PrivateRouteItermediateAccounts>
                        <VerifiedPaymentsIntermediate11 />
                      </PrivateRouteItermediateAccounts>
                    }
                  />
                  <Route
                    path="/intermediate-accounts-challan-pending-submission-class-xi"
                    element={
                      <PrivateRouteItermediateAccounts>
                        <ChallanPendingSubmissionIntermediate11 />
                      </PrivateRouteItermediateAccounts>
                    }
                  />
                  <Route
                    path="/intermediate-accounts-reports-class-xi"
                    element={
                      <PrivateRouteItermediateAccounts>
                        <ReportsIntermediate11 />
                      </PrivateRouteItermediateAccounts>
                    }
                  />
                  <Route
                    path="/intermediate-accounts-fees-structure-class-xi"
                    element={
                      <PrivateRouteItermediateAccounts>
                        <FeesStructureIntermediate11 />
                      </PrivateRouteItermediateAccounts>
                    }
                  />
                  <Route path="*" element={<Navigate to="/no-access" replace />} />
                  <Route path="/no-access" element={<Noaccess />} />
                </>
              ) : (
                ""
              )}
              {class12foactive === "ON" ? (
                <>
                  <Route
                    path="/intermediate-accounts-dashboard-class-xii"
                    element={
                      <PrivateRouteItermediateAccounts>
                        <AccountsDashboardIntermediate12 />
                      </PrivateRouteItermediateAccounts>
                    }
                  />
                  <Route
                    path="/intermediate-accounts-payment-pending-class-xii"
                    element={
                      <PrivateRouteItermediateAccounts>
                        <PaymentPendingIntermediate12 />
                      </PrivateRouteItermediateAccounts>
                    }
                  />
                  <Route
                    path="/intermediate-accounts-reject-payment-class-xii"
                    element={
                      <PrivateRouteItermediateAccounts>
                        <RejectedPaymentsIntermediate12 />
                      </PrivateRouteItermediateAccounts>
                    }
                  />
                  <Route
                    path="/intermediate-accounts-verified-payment-class-xii"
                    element={
                      <PrivateRouteItermediateAccounts>
                        <VerifiedPaymentsIntermediate12 />
                      </PrivateRouteItermediateAccounts>
                    }
                  />
                  <Route
                    path="/intermediate-accounts-challan-pending-submission-class-xii"
                    element={
                      <PrivateRouteItermediateAccounts>
                        <ChallanPendingSubmissionIntermediate12 />
                      </PrivateRouteItermediateAccounts>
                    }
                  />
                  <Route
                    path="/intermediate-accounts-reports-class-xii"
                    element={
                      <PrivateRouteItermediateAccounts>
                        <ReportsIntermediate12 />
                      </PrivateRouteItermediateAccounts>
                    }
                  />
                  <Route
                    path="/intermediate-accounts-fees-structure-class-xii"
                    element={
                      <PrivateRouteItermediateAccounts>
                        <FeesStructureIntermediate12 />
                      </PrivateRouteItermediateAccounts>
                    }
                  />
                  <Route path="*" element={<Navigate to="/no-access" replace />} />
                  <Route path="/no-access" element={<Noaccess />} />
                </>
              ) : (
                ""
              )}
              {/* Secondary Admin Routes */}
              <>
                <Route path="/secondary-admin" element={<AdminLoginSecondary />} />
                <Route
                  path="/secondary-admin-dashboard"
                  element={<AdminDashboardSecondary />}
                />
                <Route
                  path="/secondary-admin-edit-school"
                  element={<EditSchoolSecondary />}
                />
                <Route
                  path="/secondary-admin-add-school"
                  element={<AddSchoolSecondary />}
                />
                <Route
                  path="/secondary-admin-reset-deo-password"
                  element={<DeoListSecondary />}
                />
                <Route
                  path="/secondary-admin-school-list"
                  element={<SchoolListSecondary />}
                />
                <Route
                  path="/secondary-admin-ticker-master"
                  element={<TickerMasterSecondary />}
                />
                <Route
                  path="/secondary-admin-upload-notice-class-ix"
                  element={<UploadNotice9Secondary />}
                />
                <Route
                  path="/secondary-admin-upload-notice-class-x"
                  element={<UploadNotice10Secondary />}
                />
                <Route
                  path="/secondary-admin-class-ix-reports"
                  element={<ClassixReportsSecondary />}
                />
                <Route
                  path="/secondary-admin-class-x-reports"
                  element={<ClassxReportsSecondary />}
                />
                <Route
                  path="/secondary-admin-challan-cancel-class-ix"
                  element={<ChallanCancelSecondary9 />}
                />
                <Route
                  path="/secondary-admin-challan-cancel-class-x"
                  element={<ChallanCancelSecondary10 />}
                />
                <Route
              path="/secondary-not-found-class-ix"
              element={<NotFoundList9 />}
            />
            <Route
              path="/secondary-data-not-found-class-ix"
              element={<DataNotfound9 />}
            />
                 <Route
              path="/secondary-not-found-class-x"
              element={<NotFoundList10 />}
            />
            <Route
              path="/secondary-data-not-found-class-x"
              element={<StudentDataNotfound10 />}
            />
              <Route
                path="/secondary-admin-challan-cancel-class-ix"
                element={<ChallanCancelSecondary9 />}
              />
              <Route
                path="/secondary-admin-challan-cancel-class-x"
                element={<ChallanCancelSecondary10 />}
              />
                   <Route
              path="/secondary-admin-data-not-found-class-ix"
              element={<DataNotFountListDetails9 />}
            />
            <Route
              path="/secondary-admin-data-not-found-class-x"
              element={<DataNotFountListDetails10 />}
            />
            <Route
              path="/secondary-demographic-details-update"
              element={<Studentcorrection />}
            />
            <Route
              path="/secondary-demographic-details-update-page"
              element={<StudentCorrectionPage />}
            />
                {/* <Route
                  path="/secondary-admin-data-not-found-class-ix"
                  element={<DataNotFoundSecondary9 />}
                />
                <Route
                  path="/secondary-admin-data-not-found-class-x"
                  element={<DataNotFoundSecondary10 />}
                /> */}
              </>
              {/* Intermediate Admin Routes */}
              <>
                <Route
                  path="/intermediate-admin"
                  element={<AdminLoginIntermediate />}
                />
                <Route
                  path="/intermediate-admin-dashboard"
                  element={<AdminDashboardIntermediate />}
                />
                <Route
                  path="/intermediate-admin-add-school"
                  element={<AddSchoolIntermediate />}
                />
                <Route
                  path="/intermediate-admin-reset-deo-password"
                  element={<DeoListIntermediate />}
                />
                <Route
                  path="/intermediate-admin-intake-quota"
                  element={<IntakeQuotaIntermediate />}
                />
                <Route
                  path="/intermediate-admin-intake-quota-allocation"
                  element={<IntakeQuotaAllocationIntermediate />}
                />
                <Route
                  path="/intermediate-admin-school-list"
                  element={<SchoolListIntermediate />}
                />
                <Route
                  path="/intermediate-admin-edit-school"
                  element={<EditSchoolIntermediate />}
                />
                <Route
                  path="/intermediate-admin-add-school"
                  element={<AddSchool />}
                />
                <Route
                  path="/intermediate-admin-student-correction"
                  element={<StudentCorrectionIntermediate />}
                />
                <Route
                  path="/intermediate-admin-view-school-details"
                  element={<ViewSchoolDetailsIntermediate />}
                />
                <Route
                  path="/intermediate-admin-ticker-master"
                  element={<TickerMasterIntermediate />}
                />
                <Route
                  path="/intermediate-admin-upload-notice-class-xi"
                  element={<UploadNoticeIntermediate11 />}
                />
                <Route
                  path="/intermediate-admin-upload-notice-class-xii"
                  element={<UploadNoticeIntermediate12 />}
                />
                <Route
                  path="/intermediate-admin-class-xi-reports"
                  element={<ClassxiReportsIntermediate />}
                />
                <Route
                  path="/intermediate-admin-class-xii-reports"
                  element={<ClassxiiReportsIntermediate />}
                />
                <Route
                  path="/intermediate-admin-challan-cancel-class-xi"
                  element={<ChallanCancelIntermediate11 />}
                />
                <Route
                  path="/intermediate-admin-challan-cancel-class-xii"
                  element={<ChallanCancelIntermediate12 />}
                />
                  <Route
              path="/intermediate-not-found-class-xi"
              element={<NotFoundList11 />}
            />
            <Route
              path="/intermediate-not-found-class-xii"
              element={<NotFoundList12 />}
            />
            <Route
              path="/intermediate-data-not-found-class-xi"
              element={<DataNotfoundListInter11 />}
            />
            <Route
              path="/intermediate-data-not-found-class-xii"
              element={<DataNotfoundListInter12 />}
            />
            <Route
              path="/intermediate-admin-data-not-found-class-xii"
              element={<DataNotFountListDetails12 />}
            />
            <Route
              path="/intermediate-admin-data-not-found-class-xi"
              element={<DataNotFountListDetails11 />}
            />
            <Route
              path="/intermediate-demographic-details-update"
              element={<Studentcorrection11 />}
            />
            <Route
              path="/intermediate-demographic-details-update-page"
              element={<StudentCorrectionPage11 />}
            />
                {/* <Route
                  path="/intermediate-admin-data-not-found-class-xi"
                  element={<DataNotFoundIntermediate11 />}
                />
                <Route
                  path="/intermediate-admin-data-not-found-class-xii"
                  element={<DataNotFoundIntermediate12 />}
                /> */}
                <Route
                path="/class-xii-correct-student"
                element={
                  <PrivateRoute12>
                    <CorrectStudent12 />
                  </PrivateRoute12>
                }
              />
              <Route
                path="/class-xii-correction-regular"
                element={
                  <PrivateRoute12>
                    <CorrectRegular12 />
                  </PrivateRoute12>
                }
              />
              <Route
                path="/class-xii-correction-exregular"
                element={
                  <PrivateRoute12>
                    <CorrectExregular12 />
                  </PrivateRoute12>
                }
              />
              <Route
                path="/class-xii-correction-betterment"
                element={
                  <PrivateRoute12>
                    <CorrectBetterment12 />
                  </PrivateRoute12>
                }
              />
              <Route
                path="/class-xii-correction-qualify"
                element={
                  <PrivateRoute12>
                    <CorrectQualify12 />
                  </PrivateRoute12>
                }
              /> <Route
                path="/class-x-correct-student"
                element={
                  <PrivateRoute10>
                    <CorrectStudentPage1 />
                  </PrivateRoute10>
                }
              />
              <Route
                path="/class-x-correction-regular"
                element={
                  <PrivateRoute10>
                    <CorrectionRegular />
                  </PrivateRoute10>
                }
              />
              <Route
                path="/class-x-correction-exregular"
                element={
                  <PrivateRoute10>
                    <CorrectExregular />
                  </PrivateRoute10>
                }
              />
              <Route
                path="/class-x-correction-improvement"
                element={
                  <PrivateRoute10>
                    <CorrectImprovement />
                  </PrivateRoute10>
                }
              />

              <Route
                path="/class-xi-correct-student"
                element={
                  // <PrivateRoute11>
                  <CorrectStudent11 />
                  // </PrivateRoute11>
                }
              />
              <Route
                path="/class-xi-correction-regular"
                element={
                  //<PrivateRoute11>
                  <CorrectStudentJac11 />
                  // </PrivateRoute11>
                }
              />
              <Route
                path="/class-xi-correction-exregular"
                element={
                  // <PrivateRoute11>
                  <CorrectStudentExregular11 />
                  // </PrivateRoute11>
                }
              />
              <Route
                path="/class-xi-correction-others"
                element={
                  // <PrivateRoute11>
                  <CorrectStudentOthers11 />
                  // </PrivateRoute11>
                }
              />
              <Route
                path="/class-xi-correction-board-registration"
                element={
                  // <PrivateRoute11>
                  <CorrectStudentBeforeStudent11 />
                  // </PrivateRoute11>
                }
              />
                <Route
                path="/class-ix-correct-student"
                element={
                  <PrivateRoute>
                    <CorrectStudentPage9 />
                  </PrivateRoute>
                }
              />
              <Route
                path="/class-ix-correct-ex-student"
                element={
                  <PrivateRoute>
                    <CorrectStudentExregular9 />
                  </PrivateRoute>
                }
              />
              <Route
                path="/class-ix-correct-student-regular"
                element={
                  <PrivateRoute>
                    <CorrectStudentRegular9 />
                  </PrivateRoute>
                }
              />
              </>
              {/* No-Access */}
            </Routes>
          </Router>
        )
      )}
    </BoardProvider>
  );
}
export default App;
